import { useCurrentView } from './ModalViewStateProvider'
import { ConfirmDiscardChanges } from './views/ConfirmDiscardChanges/ConfirmDiscardChanges'
import { Default } from './views/Default/Default'

export function Content() {
  const view = useCurrentView()

  switch (view) {
    case 'default': {
      return <Default />
    }

    case 'confirm-discard-changes': {
      return <ConfirmDiscardChanges />
    }
  }
}
